
<ng-template [ngLet]="isAdmin$|async" let-isAdmin>
  @if (accessIsReady$|async) {
    @if (isAdmin) {
      <layout-contentbars-wrapper>
        <layout-contentbar-top>
          <a routerLink="" class="logo" >
            <ui-logo [quad]="true" [background]="true" scaling="match-height" openConsole></ui-logo>
          </a>
          <div class="left">
            <h2 class="page-title" [innerHTML]="pageTitle$|async"></h2>
          </div>
          <ul class="right topbar-menu fadeInDown" >
            <core-widget [widget]="{id:'app-toolbar-right'}"></core-widget>
            @if (loggedIn$|async) {
              <li >
                <maintenance-info-icon></maintenance-info-icon>
              </li>
            }
            @if (loggedIn$|async) {
              <li #profile >
                <ui-menu #menu [popup]="true" [model]="topMenuModel" appendTo="body"></ui-menu>
                <a (click)="menu.toggle($event)">
                  <!-- <img src="assets/layout/images/avatar.png" alt="manhattan-layout" width="40" /> -->
                  @if (userData$|async; as userData) {
                    <span class="topbar-item-name profile-name">
                      Hi {{userData?.firstName}}!
                      <ui-icon icon="chevron-down"></ui-icon>
                    </span>
                  } @else {
                    <span class="topbar-item-name profile-name" >
                      lade...
                    </span>
                  }
                </a>
              </li>
            }
          </ul>
        </layout-contentbar-top>
        <layout-sidebar-wrapper>
          <router-outlet-fullscreen></router-outlet-fullscreen>
          <layout-sidebar [menuModel]="menuModel" ></layout-sidebar>
        </layout-sidebar-wrapper>
      </layout-contentbars-wrapper>
    }
    @if (!(isAdmin$|async)) {
      <div class="layout-content" >
        <user-authentication [resetPasswordEnabled]="false">
          <ui-logo [scaling]="140" [background]="true" style="margin:0 auto" openConsole></ui-logo>
        </user-authentication>
      </div>
    }
  }


  <core-root-outlet></core-root-outlet>
  <ui-confirmDialog header="Bestätigung erforderlich" icon="exclamation-triangle"></ui-confirmDialog>
